// extracted by mini-css-extract-plugin
module.exports = {"panel":"ConceptsPanel-module__panel__2UURn","scroller":"ConceptsPanel-module__scroller__20ucc"};